import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class CenterService {

    constructor(private http: HttpClient) { }

    getAllCenterWithCount(body: any): Observable<any> {
        return this.http.post(environment.getAllCenterWithCount, body);
    }


    createCenter(body: any): Observable<any> {
        return this.http.post(environment.createCenter, body);
    }

    updateCenter(body: any): Observable<any> {
        return this.http.put(environment.updateCenter, body);
    }

    deleteCenter(body: any): Observable<any> {
        return this.http.delete(environment.deleteCenter, { body: body });
    }

    
}
